import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentpune() {



const cardData = {
keyword: "Mini Bus On Rent in Pune",
headingDescription: "Ruturaj Enterprises offers comfortable and dependable Mini Bus On Rent in Pune for families, corporate groups, school tours, wedding functions, airport transfers, local travel, sightseeing, picnics, and outstation journeys. With spacious seating, convenient travel arrangements, and vehicle options suited to different group sizes and trip requirements, our mini bus rental services make group transportation across Pune and nearby destinations easier, organized, and comfortable.",
topPlaces: [

{
title: "Sinhagad Fort",
description: "Sinhagad Fort is a favorite destination for group outings, weekend excursions, college trips, and family picnics around Pune. A rented mini bus provides practical transportation for groups carrying bags, refreshments, and other travel essentials for a comfortable day trip."
},
{
title: "Lonavala",
description: "Lonavala is a popular hill destination for family holidays, corporate outings, picnics, and weekend group trips from Pune. A mini bus offers a convenient way for everyone to travel together without the need for multiple cars, making the journey more coordinated."
},
{
title: "Khandala",
description: "Khandala attracts groups looking for scenic mountain views, relaxed vacations, and short weekend getaways near Pune. A comfortable mini bus is suitable for families, friends, and corporate groups who want shared transportation throughout their trip."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a well-known destination for extended family trips, group vacations, school excursions, and corporate tours from Pune. Mini bus rentals provide spacious group transportation for the journey while allowing travelers to remain together throughout the tour."
},
{
title: "Shaniwar Wada",
description: "Shaniwar Wada is one of Pune’s most recognized historical landmarks and a popular choice for local sightseeing groups. A mini bus makes it convenient for families, school groups, and tourists to travel together while exploring the fort and nearby attractions."
},
{
title: "Aga Khan Palace",
description: "Aga Khan Palace is an important historical and architectural attraction in Pune, visited by families, educational groups, and tourists throughout the year. Hiring a mini bus allows larger groups to reach the location together with convenient seating and coordinated transportation."
},
{
title: "Lavasa",
description: "Lavasa is a scenic destination that works well for corporate outings, family trips, college groups, and recreational picnics. With a mini bus rental, groups can travel conveniently from Pune and organize their sightseeing schedule without depending on separate private vehicles."
},
{
title: "Pawna Lake",
description: "Pawna Lake is a popular choice for camping, picnics, family outings, and group weekend trips near Pune. A mini bus can accommodate travelers and their luggage more efficiently, making it a useful option for groups planning a shared outdoor experience."
},
{
title: "Jejuri",
description: "Jejuri is known for the famous Khandoba Temple and attracts pilgrims and visitors from Pune and surrounding areas. A mini bus rental is especially useful for family and religious groups who prefer traveling together with a planned pickup and drop-off arrangement."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal getaway for families, friends, corporate groups, and weekend travelers from Pune. Renting a mini bus makes long-distance group travel more convenient by keeping passengers together while providing sufficient space for luggage and trip essentials."
}
],
services: [
{
name: "Mini Bus Rental Pune",
description: "Ruturaj Enterprises provides Mini Bus Rental Pune services for local sightseeing, family outings, corporate transportation, functions, tours, and group travel. Vehicles can be selected according to group size, journey duration, comfort requirements, and destination, helping passengers enjoy a practical and well-organized travel experience."
},
{
name: "Mini Bus Hire in Pune",
description: "Mini Bus Hire in Pune is a convenient solution when several passengers need to travel together for an event, tour, transfer, or private function. Ruturaj Enterprises focuses on comfortable group transportation with suitable seating arrangements and flexible travel planning for different types of journeys."
},
{
name: "Mini Bus Booking Pune",
description: "Mini Bus Booking Pune through Ruturaj Enterprises can be planned for local and outstation requirements, including weddings, school trips, corporate events, airport transfers, and family tours. Advance booking helps groups arrange an appropriate vehicle and coordinate pickup, travel schedules, and destination requirements more efficiently."
},
{
name: "AC Mini Bus on Rent Pune",
description: "AC Mini Bus on Rent Pune is a suitable choice for passengers who want a cooler and more comfortable journey, especially during warm weather and longer routes. These vehicles are useful for families, corporate groups, tourists, wedding guests, and travelers who prefer convenient shared transportation."
},
{
name: "Non AC Mini Bus on Rent Pune",
description: "Non AC Mini Bus on Rent Pune offers a practical group transportation option for passengers looking for economical travel arrangements. It can be used for local movements, school excursions, short-distance trips, events, functions, and group journeys where air conditioning is not essential."
},
{
name: "Luxury Mini Bus on Rent Pune",
description: "Luxury Mini Bus on Rent Pune is designed for groups seeking a more premium and comfortable travel experience. Ruturaj Enterprises can accommodate requirements for corporate movements, special occasions, wedding transportation, private tours, and important group journeys where enhanced comfort is preferred."
},
{
name: "Mini Bus for Outstation Pune",
description: "Mini Bus for Outstation Pune is a useful transportation choice for groups traveling from Pune to nearby cities, hill stations, pilgrimage destinations, beaches, and other long-distance locations. Shared travel helps passengers stay together while making the overall journey easier to coordinate."
},
{
name: "Mini Bus for Corporate Events Pune",
description: "Mini Bus for Corporate Events Pune helps companies manage transportation for conferences, meetings, exhibitions, employee gatherings, team outings, and business functions. Group transportation reduces the need for multiple vehicles and supports smoother movement between offices, hotels, venues, and event locations."
},
{
name: "Mini Bus for Wedding Pune",
description: "Mini Bus for Wedding Pune is suitable for transporting relatives, guests, family members, and wedding groups between homes, hotels, banquet halls, temples, and ceremony venues. Ruturaj Enterprises helps organize shared transportation so guests can travel together according to the planned wedding schedule."
},
{
name: "Mini Bus for School Trips Pune",
description: "Mini Bus for School Trips Pune provides convenient transportation for educational visits, excursions, recreational outings, and student group activities. Schools and organizers can plan suitable pickup and drop-off arrangements while keeping students and accompanying staff together during the journey."
},
{
name: "Mini Bus for Family Trip Pune",
description: "Mini Bus for Family Trip Pune is ideal when relatives or extended families want to enjoy a vacation without splitting into multiple cars. Spacious group transportation makes it easier to carry luggage and travel together for sightseeing, religious visits, weekend holidays, and longer family tours."
},
{
name: "Mini Bus for Group Travel Pune",
description: "Mini Bus for Group Travel Pune offers an organized solution for friends, relatives, colleagues, tourists, and other groups traveling to the same destination. Ruturaj Enterprises supports local and outstation group journeys with vehicle options that can match the number of passengers and overall travel plan."
},
{
name: "Mini Bus for Airport Pickup Pune",
description: "Mini Bus for Airport Pickup Pune is convenient for families, corporate teams, wedding guests, and larger groups arriving at or departing from Pune Airport. Coordinated group pickup helps passengers travel together with their luggage instead of arranging several smaller vehicles."
},
{
name: "Affordable Mini Bus Rental Pune",
description: "Affordable Mini Bus Rental Pune provides a cost-conscious transportation option for groups that want to share one vehicle instead of booking multiple cars. Ruturaj Enterprises offers practical solutions for local travel, functions, picnics, tours, corporate movements, and outstation journeys based on the group’s requirements."
},
{
name: "Mini Bus Rental Service Pune",
description: "Mini Bus Rental Service Pune from Ruturaj Enterprises can be arranged for short trips, full-day programs, events, sightseeing schedules, airport transfers, and multi-day tours. The service is planned around passenger requirements, destination, travel duration, pickup points, and the type of journey being undertaken."
},
{
name: "Mini Bus for Picnic Pune",
description: "Mini Bus for Picnic Pune is a convenient option for families, friends, schools, offices, and community groups planning recreational outings. Travelers can remain together throughout the journey while carrying food, bags, outdoor equipment, and other essentials required for a comfortable picnic."
},
{
name: "Mini Bus for Corporate Transportation Pune",
description: "Mini Bus for Corporate Transportation Pune supports employee transfers, office movements, training programs, business meetings, corporate tours, and company events. Shared transportation can simplify daily or scheduled group movements while helping organizations coordinate employees between different locations."
},
{
name: "Mini Bus for Marriage Function Pune",
description: "Mini Bus for Marriage Function Pune is useful for moving wedding guests and family members between multiple venues during marriage ceremonies. From hotel transfers to reception halls and traditional function locations, a dedicated mini bus helps maintain an organized transportation schedule."
},
{
name: "Mini Bus for Event Pune",
description: "Mini Bus for Event Pune can be arranged for exhibitions, cultural programs, private celebrations, conferences, social gatherings, and other occasions requiring group transportation. Ruturaj Enterprises helps event organizers manage shared passenger movement between pickup locations, venues, hotels, and other planned destinations."
},
{
name: "Mini Bus for Local Travel Pune",
description: "Mini Bus for Local Travel Pune is suitable for city sightseeing, family functions, group movements, institutional visits, shopping trips, and local events. Hiring one vehicle allows the entire group to travel according to a common schedule without depending on multiple private cars or separate transport arrangements."
},
{
name: "Mini Bus for Tourist Trip Pune",
description: "Mini Bus for Tourist Trip Pune provides comfortable shared transportation for sightseeing tours, weekend holidays, destination visits, and planned tourist circuits. Groups can select a suitable travel arrangement based on their itinerary and enjoy the convenience of traveling together from one attraction to another."
},
{
name: "Mini Bus for Outstation Tour Pune",
description: "Mini Bus for Outstation Tour Pune is a practical choice for groups planning longer journeys from Pune to destinations across Maharashtra and neighboring states. Whether the trip is for sightseeing, pilgrimage, family vacation, corporate travel, or a weekend tour, shared mini bus transportation keeps the group together and simplifies travel planning."
}
],
tableData: [
["Mini Bus Rental Pune", "Mini Bus Hire in Pune"],
["Mini Bus Booking Pune", "AC Mini Bus on Rent Pune"],
["Non AC Mini Bus on Rent Pune", "Luxury Mini Bus on Rent Pune"],
["Mini Bus for Outstation Pune", "Mini Bus for Corporate Events Pune"],
["Mini Bus for Wedding Pune", "Mini Bus for School Trips Pune"],
["Mini Bus for Family Trip Pune", "Mini Bus for Group Travel Pune"],
["Mini Bus for Airport Pickup Pune", "Affordable Mini Bus Rental Pune"],
["Mini Bus Rental Service Pune", "Mini Bus for Picnic Pune"],
["Mini Bus for Corporate Transportation Pune", "Mini Bus for Marriage Function Pune"],
["Mini Bus for Event Pune", "Mini Bus for Local Travel Pune"],
["Mini Bus for Tourist Trip Pune", "Mini Bus for Outstation Tour Pune"]
],
whychoose: [
{
WhyChooseheading: "Suitable Vehicles for Different Group Sizes",
WhyChoosedescription: "Group transportation requirements can vary significantly depending on the number of passengers and type of journey. Ruturaj Enterprises helps travelers choose a suitable mini bus arrangement for family outings, corporate movements, school excursions, weddings, sightseeing programs, and private tours."
},
{
WhyChooseheading: "Comfortable Shared Travel",
WhyChoosedescription: "Traveling together in one vehicle makes group journeys more convenient and coordinated. Passengers can stay together throughout the trip, communicate easily, manage luggage collectively, and avoid the inconvenience of coordinating several separate cars."
},
{
WhyChooseheading: "Local and Outstation Flexibility",
WhyChoosedescription: "From Pune city travel to longer journeys outside the city, mini bus rentals can support a wide range of itineraries. Whether the requirement is for a few hours, a full day, a weekend trip, or a multi-day tour, the transportation plan can be arranged around the group's schedule."
},
{
WhyChooseheading: "Useful for Multiple Occasions",
WhyChoosedescription: "A mini bus can serve many transportation needs beyond regular sightseeing. Wedding functions, corporate events, school trips, airport transfers, family vacations, picnics, tourist tours, and private celebrations can all benefit from a dedicated group vehicle."
},
{
WhyChooseheading: "Convenient Airport and Event Transfers",
WhyChoosedescription: "Moving a large group between airports, hotels, offices, banquet halls, and event venues becomes easier with shared transportation. A dedicated mini bus reduces the need to coordinate multiple pickup times and helps keep passengers together during important transfers."
},
{
WhyChooseheading: "Practical Option for Group Budgets",
WhyChoosedescription: "When several people are traveling to the same destination, sharing a mini bus can be a practical alternative to arranging numerous individual vehicles. This approach simplifies transportation management while allowing the group to plan its travel according to a common itinerary."
},
{
WhyChooseheading: "Convenient for Family and Tourist Tours",
WhyChoosedescription: "Families and tourist groups often carry luggage, shopping bags, refreshments, and other travel essentials during their journeys. A mini bus provides a shared travel environment that makes sightseeing and destination-to-destination movement more comfortable and organized."
},
{
WhyChooseheading: "Planned Transportation for Special Events",
WhyChoosedescription: "Events and functions often involve transportation between several locations and require passengers to arrive according to a fixed schedule. Ruturaj Enterprises supports such requirements with group-oriented mini bus arrangements suitable for weddings, corporate programs, school activities, private events, and organized tours."
}
]
};





const faqData = [
{
question: "Why choose Ruturaj Enterprises for a Mini Bus on rent in Pune?",
answer: "Ruturaj Enterprises provides convenient Mini Bus rental options for groups that need spacious and coordinated transportation in Pune and for outstation journeys. The service is suitable for family functions, corporate events, school trips, weddings, tours, and group travel."
},
{
question: "Who can hire a Mini Bus in Pune?",
answer: "Mini Buses can be rented by families, companies, schools, colleges, wedding groups, tour operators, social organizations, and other parties requiring transportation for multiple passengers. The vehicle can be selected according to the group's size and travel requirements."
},
{
question: "Can I rent a Mini Bus in Pune for an outstation trip?",
answer: "Outstation Mini Bus rentals can be arranged from Pune for group journeys to destinations such as Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, Kolhapur, and other locations. Ruturaj Enterprises can organize transportation around the planned route and schedule."
},
{
question: "Is a Mini Bus suitable for family functions and gatherings?",
answer: "Family groups can use a Mini Bus for weddings, receptions, anniversaries, religious functions, family reunions, and other occasions where several relatives need to travel together. Having one vehicle makes group coordination more convenient."
},
{
question: "Can companies hire a Mini Bus for corporate transportation?",
answer: "Corporate organizations can arrange Mini Buses for employee transportation, conferences, meetings, office events, team outings, training programs, and business visits. Group travel helps employees stay together while following a planned schedule."
},
{
question: "Can I book a Mini Bus for a wedding in Pune?",
answer: "Wedding parties can hire a Mini Bus for transporting guests between homes, hotels, wedding venues, reception halls, railway stations, and airports. Ruturaj Enterprises can arrange group transportation according to the event schedule and passenger requirements."
},
{
question: "Can a Mini Bus be used for school and college trips?",
answer: "Educational institutions and student groups can consider Mini Bus rentals for educational tours, industrial visits, picnics, excursions, and cultural programs. A group vehicle provides an organized transportation solution for planned journeys."
},
{
question: "Is a Mini Bus available for Pune sightseeing?",
answer: "Groups can rent a Mini Bus for Pune sightseeing when they want to visit several attractions together. It can be useful for family tours, visiting groups, corporate outings, and organized city excursions with multiple planned stops."
},
{
question: "Can I hire a Mini Bus for a one-day trip from Pune?",
answer: "One-day Mini Bus rentals are suitable for groups planning short excursions, sightseeing programs, religious visits, picnics, or nearby weekend trips. The itinerary can be customized around the group's preferred departure point and destinations."
},
{
question: "How can I book a Mini Bus on rent in Pune with Ruturaj Enterprises?",
answer: "To make a booking, share your pickup location, travel date, destination, number of passengers, trip duration, and transportation requirements with Ruturaj Enterprises. A suitable Mini Bus option can then be arranged according to your group travel plan."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rakesh Gaikwad",
feedback:
"Ruturaj Enterprises arranged a Mini Bus for our family function in Pune, and it made guest transportation much easier. The group could travel together between the different locations, and the overall arrangement was convenient and comfortable.",
rating: 5
},
{
id: 2,
name: "Miss. Tanvi Deshpande",
feedback:
"Our company hired a Mini Bus from Ruturaj Enterprises for a team outing. The group transportation was easy to coordinate, the vehicle was comfortable, and everyone could travel together according to our planned schedule. We were satisfied with the service.",
rating: 5
}
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/mini-bus-on-rent-in-pune.webp",
  "description":
    "Mini Bus On Rent in Pune from Ruturaj Enterprises is a practical group transportation solution for families, friends, tourists, corporate teams, schools, colleges, wedding groups and organizations requiring comfortable travel within Pune or to outstation destinations. Mini Bus Rental Pune is suitable for local sightseeing, airport transfers, railway station transfers, corporate transportation, employee travel, school trips, college tours, weddings, family functions, group outings and long-distance journeys. Mini Bus Hire in Pune provides a convenient option for groups that want to travel together instead of arranging multiple smaller vehicles, while Mini Bus Booking Pune can be planned according to passenger requirements, pickup location, travel duration and itinerary. AC Mini Bus on Rent Pune is suitable for comfortable travel in warm weather and longer journeys, while Non AC Mini Bus on Rent Pune can be considered for suitable budget-oriented transportation requirements. Luxury Mini Bus on Rent Pune provides a more premium travel experience for corporate events, weddings, special occasions and organized group tours. Mini Bus for Outstation Pune can be arranged for popular destinations such as Mumbai, Lonavala, Mahabaleshwar, Panchgani, Nashik, Shirdi, Kolhapur, Satara, Goa, Konkan, Alibaug, Matheran and other Maharashtra and interstate destinations. Mini Bus for Corporate Events Pune is useful for conferences, seminars, exhibitions, meetings, employee outings, team-building programs, client visits and business travel. Mini Bus for Wedding Pune can support guest transportation between hotels, wedding venues, reception locations, airports and railway stations. Additional services can be arranged for family vacations, tourist groups, school excursions, college trips, pilgrimage tours, industrial visits and customized multi-day journeys. Pune pickup can be arranged from Kothrud, Baner, Aundh, Wakad, Hinjewadi, Pimpri, Chinchwad, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Talegaon, Moshi, Bhosari and nearby areas. The vehicle can also support airport and railway station transfers, hotel pickups, corporate office transportation and event-related group movement. Ruturaj Enterprises provides flexible Mini Bus rental arrangements with experienced drivers for local and outstation group travel, corporate transportation, wedding events, family tours, sightseeing, school trips and customized travel requirements from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/mini-bus-on-rent-in-pune"
  }
};









    return (
        <div>
<Helmet>
  <title>Mini Bus On Rent in Pune | Mini Bus Rental Pune | +91 9763381382</title>

  <meta
    name="description"
    content="Mini Bus On Rent in Pune for corporate events, weddings, family trips, school tours, group travel, local sightseeing and outstation journeys. Hire AC, Non AC and Luxury Mini Buses with driver."
  />

  <meta
    name="keywords"
    content="Mini Bus Rental Pune, Mini Bus Hire in Pune, Mini Bus Booking Pune, AC Mini Bus on Rent Pune, Non AC Mini Bus on Rent Pune, Luxury Mini Bus on Rent Pune, Mini Bus for Outstation Pune, Mini Bus for Corporate Events Pune, Mini Bus for Wedding Pune, Mini Bus On Rent in Pune, Mini Bus Rental Service Pune, Mini Bus Hire Pune, Mini Bus Booking in Pune, Mini Bus with Driver Pune, Private Mini Bus Pune, AC Mini Bus Hire Pune, AC Mini Bus Rental Pune, Non AC Mini Bus Hire Pune, Non AC Mini Bus Rental Pune, Luxury Mini Bus Hire Pune, Luxury Mini Bus Rental Pune, Premium Mini Bus Pune, Affordable Mini Bus Pune, Budget Mini Bus Rental Pune, Comfortable Mini Bus Pune, Mini Bus for Family Trip Pune, Mini Bus for Group Travel Pune, Mini Bus for Friends Trip Pune, Mini Bus for Tourist Group Pune, Mini Bus for Family Tour Pune, Mini Bus for Weekend Trip Pune, Mini Bus for Holiday Trip Pune, Mini Bus for Road Trip Pune, Mini Bus for Vacation Pune, Mini Bus for Sightseeing Pune, Mini Bus for Local Sightseeing Pune, Mini Bus for Pune Darshan, Mini Bus for Temple Tour Pune, Mini Bus for Pilgrimage Pune, Mini Bus for Religious Tour Pune, Mini Bus for School Trip Pune, Mini Bus for College Trip Pune, Mini Bus for Student Group Pune, Mini Bus for Picnic Pune, Mini Bus for Industrial Visit Pune, Mini Bus for Corporate Travel Pune, Mini Bus for Corporate Trip Pune, Mini Bus for Corporate Outing Pune, Mini Bus for Employee Transportation Pune, Mini Bus for Office Staff Pune, Mini Bus for Company Transport Pune, Mini Bus for Business Travel Pune, Mini Bus for Conference Pune, Mini Bus for Seminar Pune, Mini Bus for Exhibition Pune, Mini Bus for Meeting Pune, Mini Bus for Training Pune, Mini Bus for Client Visit Pune, Mini Bus for Team Outing Pune, Mini Bus for Wedding Guest Pune, Mini Bus for Marriage Pune, Mini Bus for Reception Pune, Mini Bus for Baraat Pune, Mini Bus for Family Function Pune, Mini Bus for Destination Wedding Pune, Mini Bus for Event Transportation Pune, Mini Bus for Guest Transportation Pune, Mini Bus for Airport Transfer Pune, Mini Bus for Airport Pickup Pune, Mini Bus for Airport Drop Pune, Mini Bus for Pune Airport, Mini Bus for Railway Station Transfer Pune, Mini Bus for Pune Railway Station, Mini Bus for Hotel Transfer Pune, Mini Bus for Resort Transfer Pune, Mini Bus for Corporate Office Transfer Pune, Mini Bus for Employee Pickup Drop Pune, Mini Bus Full Day Rental Pune, Mini Bus Half Day Rental Pune, Mini Bus Hourly Rental Pune, Mini Bus Multi Day Rental Pune, Mini Bus Weekend Rental Pune, Mini Bus Outstation Rental Pune, Mini Bus One Way Rental Pune, Mini Bus Round Trip Pune, Mini Bus Tour Package Pune, Mini Bus Sightseeing Package Pune, Mini Bus Family Tour Package Pune, Mini Bus Group Tour Package Pune, Mini Bus Corporate Tour Package Pune, Mini Bus Wedding Transportation Pune, Mini Bus School Tour Package Pune, Mini Bus College Tour Package Pune, Mini Bus Pilgrimage Tour Package Pune, Mini Bus Religious Tour Package Pune, Mini Bus Local Transportation Pune, Mini Bus Group Transportation Pune, Mini Bus Family Transportation Pune, Mini Bus Tourist Transportation Pune, Mini Bus Corporate Transportation Pune, Mini Bus Wedding Transportation Service Pune, Mini Bus Event Transportation Pune, Mini Bus Private Rental Pune, Mini Bus Rental with Driver Pune, Mini Bus Hire with Driver Pune, Mini Bus Booking with Driver Pune, Mini Bus for Outstation Trip Pune, Mini Bus for Maharashtra Tour Pune, Mini Bus for Goa Trip Pune, Mini Bus for Konkan Trip Pune, Mini Bus for Mumbai Trip Pune, Mini Bus for Lonavala Trip Pune, Mini Bus for Mahabaleshwar Trip Pune, Mini Bus for Panchgani Trip Pune, Mini Bus for Nashik Trip Pune, Mini Bus for Shirdi Trip Pune, Mini Bus for Kolhapur Trip Pune, Mini Bus for Satara Trip Pune, Mini Bus for Alibaug Trip Pune, Mini Bus for Matheran Trip Pune, Mini Bus for Ratnagiri Trip Pune, Mini Bus for Ganpatipule Trip Pune, Mini Bus for Dapoli Trip Pune, Mini Bus for Konkan Tour Pune, Mini Bus for Goa Tour Pune, Mini Bus for Mumbai Tour Pune, Mini Bus for Maharashtra Sightseeing Pune, Mini Bus for Family Vacation Pune, Mini Bus for Group Vacation Pune, Mini Bus for Corporate Vacation Pune, Mini Bus for Weekend Getaway Pune, Mini Bus for Beach Trip Pune, Mini Bus for Hill Station Trip Pune, Mini Bus for Long Distance Travel Pune, Mini Bus for Intercity Travel Pune, Mini Bus for Road Trip Group Pune, Mini Bus for Tourist Tour Pune, Mini Bus for Corporate Event Transportation Pune, Mini Bus for Wedding Guest Transportation Pune, Mini Bus for School Transportation Pune, Mini Bus for College Transportation Pune, Mini Bus for Employee Transportation Pune, Mini Bus for Staff Transportation Pune, Mini Bus for Company Event Pune, Mini Bus for Business Event Pune, Mini Bus for Conference Transportation Pune, Mini Bus for Exhibition Transportation Pune, Mini Bus for Seminar Transportation Pune, Mini Bus for Training Transportation Pune, Mini Bus for Client Transportation Pune, Mini Bus for Executive Transportation Pune, Mini Bus for Guest Pickup Pune, Mini Bus for Guest Drop Pune, Mini Bus for Hotel Pickup Pune, Mini Bus for Hotel Drop Pune, Mini Bus for Airport to Hotel Pune, Mini Bus for Airport to City Pune, Mini Bus for Railway Station to Hotel Pune, Mini Bus for Wedding Venue Transfer Pune, Mini Bus for Event Venue Transfer Pune, Mini Bus Rental Near Pune, Mini Bus Hire Near Pune, Mini Bus Booking Near Pune, Mini Bus Rental Pimpri Chinchwad, Mini Bus Hire Pimpri Chinchwad, Mini Bus Rental Wakad, Mini Bus Rental Hinjewadi, Mini Bus Rental Kothrud, Mini Bus Rental Baner, Mini Bus Rental Aundh, Mini Bus Rental Viman Nagar, Mini Bus Rental Kharadi, Mini Bus Rental Hadapsar, Mini Bus Rental Kondhwa, Mini Bus Rental Katraj, Mini Bus Rental Shivajinagar, Mini Bus Rental Swargate, Mini Bus Rental Pimpri, Mini Bus Rental Chinchwad, Mini Bus Rental Nigdi, Mini Bus Rental Akurdi, Mini Bus Rental Talegaon, Mini Bus Rental Moshi, Mini Bus Rental Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/09.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Minibusonrentpune ;